'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var uaParserJs = require('ua-parser-js');

var Device = /** @class */ (function () {
    function Device() {
        this.info = null;
        var inst = new uaParserJs.UAParser(navigator.userAgent);
        this.userAgent = navigator.userAgent;
        this.info = inst.getResult();
    }
    /* devices */
    Device.prototype.checkUserAgentChanges = function () {
        if (this.userAgent !== navigator.userAgent) {
            var inst = new uaParserJs.UAParser(navigator.userAgent);
            this.userAgent = navigator.userAgent;
            this.info = inst.getResult();
        }
    };
    /**
     * @method getDeviceType
     * @return {'console|'mobile'|'tablet'|'smarttv'|'wearable'|'embedded'}
     * */
    Device.prototype.getDeviceType = function () {
        this.checkUserAgentChanges();
        return this.isIpad() ? 'tablet' : this.info.device.type || 'other';
    };
    Device.prototype.isAnyMobile = function () {
        this.checkUserAgentChanges();
        return (this.isTablet() || this.isMobile() || this.isWearable() || this.isIphone() || this.isIpad());
    };
    Device.prototype.isAppleDevice = function () {
        this.checkUserAgentChanges();
        return this.isIOS() || this.isMacOs() || this.isIpad() || (this.info.device.vendor && this.info.device.vendor.toLowerCase()
            .indexOf('apple') !== -1);
    };
    Device.prototype.isHuaweiDevice = function () {
        this.checkUserAgentChanges();
        return this.info.device.vendor && this.info.device.vendor.toLowerCase().includes('huawei');
    };
    Device.prototype.isTablet = function () {
        this.checkUserAgentChanges();
        return (this.info.device.type || '').toLowerCase().indexOf('tablet') !== -1 || this.isIpad();
    };
    Device.prototype.isMobile = function () {
        this.checkUserAgentChanges();
        return (this.info.device.type || '').toLowerCase().indexOf('mobile') !== -1;
    };
    Device.prototype.isWearable = function () {
        this.checkUserAgentChanges();
        return (this.info.device.type || '').toLowerCase().indexOf('wearable') !== -1;
    };
    Device.prototype.isIpad = function () {
        this.checkUserAgentChanges();
        return (this.info.device.model || '').toLowerCase()
            .indexOf('ipad') !== -1 || (/Macintosh/i.test(this.info.ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
    };
    Device.prototype.isIphone = function () {
        this.checkUserAgentChanges();
        return (this.info.device.model || '').toLowerCase().indexOf('iphone') !== -1;
    };
    /** OS */
    Device.prototype.getOsName = function () {
        this.checkUserAgentChanges();
        return this.info.os.name || 'unknown';
    };
    Device.prototype.getOsVersion = function () {
        this.checkUserAgentChanges();
        return this.info.os.version || 'unknown';
    };
    Device.prototype.isAndroid = function () {
        this.checkUserAgentChanges();
        return (this.info.os.name || '').toLowerCase().indexOf('android') !== -1;
    };
    Device.prototype.isWindows = function () {
        this.checkUserAgentChanges();
        return (this.info.os.name || '').toLowerCase().indexOf('windows') !== -1;
    };
    Device.prototype.isIOS = function () {
        this.checkUserAgentChanges();
        return (this.info.os.name || '').toLowerCase().indexOf('ios') !== -1;
    };
    Device.prototype.isMacOs = function () {
        this.checkUserAgentChanges();
        return (this.info.os.name || '').toLowerCase().indexOf('mac os') !== -1;
    };
    /** browsers */
    Device.prototype.getBrowserName = function () {
        this.checkUserAgentChanges();
        return this.info.browser.name || 'unknown';
    };
    Device.prototype.getBrowserVersion = function () {
        this.checkUserAgentChanges();
        return this.info.browser.version || '0';
    };
    Device.prototype.isIE = function () {
        this.checkUserAgentChanges();
        return (this.info.browser.name || '').toLowerCase().indexOf('ie') !== -1;
    };
    Device.prototype.isEdge = function () {
        this.checkUserAgentChanges();
        return (this.info.browser.name || '').toLowerCase().indexOf('edge') !== -1;
    };
    Device.prototype.isSafari = function () {
        this.checkUserAgentChanges();
        return (this.info.browser.name || '').toLowerCase().indexOf('safari') !== -1;
    };
    Device.prototype.isOpera = function () {
        this.checkUserAgentChanges();
        return (this.info.browser.name || '').toLowerCase().indexOf('opera') !== -1;
    };
    Device.prototype.isFirefox = function () {
        this.checkUserAgentChanges();
        return (this.info.browser.name || '').toLowerCase().indexOf('firefox') !== -1;
    };
    Device.prototype.isChrome = function () {
        this.checkUserAgentChanges();
        return (this.info.browser.name || '').toLowerCase().indexOf('chrome') !== -1;
    };
    /** desktop sizes */
    Device.prototype.isMobileSize = function () {
        this.checkUserAgentChanges();
        return (window.innerWidth < 999);
    };
    Device.prototype.isMobileScreen = function () {
        this.checkUserAgentChanges();
        return (window.innerWidth > 0) && (window.innerWidth < 640);
    };
    Device.prototype.isTabletScreen = function () {
        this.checkUserAgentChanges();
        return (window.innerWidth > 639) && (window.innerWidth < 1024);
    };
    Device.prototype.isDesktopScreen = function () {
        this.checkUserAgentChanges();
        return (window.innerWidth > 1023);
    };
    Device.prototype.connectionType = function () {
        this.checkUserAgentChanges();
        var netType = null;
        var nav = navigator;
        var connectionInst = (nav.connection || nav.mozConnection || nav.webkitConnection);
        var type = netType || ((connectionInst === null || connectionInst === void 0 ? void 0 : connectionInst.type) || (connectionInst === null || connectionInst === void 0 ? void 0 : connectionInst.effectiveType) || '').toLowerCase();
        return type && type !== 'unknown' ? type : 'unavailable';
    };
    return Device;
}());
var device = new Device();

exports.Device = Device;
exports.device = device;
